import { LucideColumns2, LucidePanelLeft, LucidePanelRight } from '@lucide/angular';

export const LAYOUTS = ['panel-left', 'columns-2', 'panel-right'] as const;
export type Layout = (typeof LAYOUTS)[number];

export function lucideFromLayout(layout: Layout) {
  switch (layout) {
    case 'panel-left':
      return LucidePanelLeft;
    case 'columns-2':
      return LucideColumns2;
    case 'panel-right':
      return LucidePanelRight;
  }
}
